// When cart-drawer updates, check for gift tier eligibility
document.addEventListener("DOMContentLoaded", async function () {
	// Run initially on page load
	await removeLegacyGift();
	
	promotionFeatures(window.promotions);
	// Select the node that will be observed for mutations
	const cartNode = document.querySelector("cart-drawer");
	// Options for the observer (which mutations to observe)
	const config = { attributes: true, childList: true, subtree: true };
	let callbackTimes = 0;
	// Callback function to execute when mutations are observed
	const callback = async function (mutationsList, observer) {
		for (let mutation of mutationsList) {
			if (mutation.type === "childList") {
				callbackTimes++;
				// Disconnect the observer
				observer.disconnect();

				// Apply Gift Tier Promotion Logic
				await promotionFeatures(window.promotions);

				// Reconnect the observer
				observer.observe(cartNode, config);
			}
		}
	};
	// Create an observer instance linked to the callback function
	const observer = new MutationObserver(callback);
	// Start observing the cartNode for configured mutations
	observer.observe(cartNode, config);
});

let timesInHere = 0;

async function removeLegacyGift() {
	const cartData = await window.getCartData();
	const legacyGift = cartData.items.find((item) => item.variant_id === 44323405234228);
	if (legacyGift) {
		await window.updateGiftItems([
			{
				key: legacyGift.key,
			}
		], 0);
	}
}

// Handle gift tier eligibility
async function promotionFeatures(promotions) {
	// Cart data collection
	const cartData = await getCartData();
	const cartSubtotal = cartData.total_price;
	const cartQuantity = cartData.item_count;
	const cartItems = cartData.items;
	const oldPromoItems = cartItems.filter(item => item.properties && item.properties._promo);
	// const tryNowItems = cartItems.filter(item => item.product_id === 7431170097204);
	const promoItems = cartItems.filter(item => {
		return window.giftProducts?.includes(item.product_id);
	});
	const subtotalWithoutPromoItems = promoItems.reduce((subtotal, item) => subtotal - item.final_line_price, cartSubtotal);
	let subCartSubTotal = 0;
	let subCartQuantity = 0;
	cartItems.forEach((item) => {
		if (item.selling_plan_allocation) {
			subCartSubTotal += item.final_line_price;
			subCartQuantity += item.quantity;
		}
	});
	const giftPromo = promotions.find(promo => promo.promo === 'gift_tier');

	// if (oldPromoItems?.length > 0) {
	// 	await updateGiftItems(oldPromoItems, 0, () => promotionFeatures(window.promotions));
	// }
	
	// if (tryNowItems?.length > 0) {
	// 	await updateGiftItems(tryNowItems, 0, () => promotionFeatures(window.promotions));
	// }
	
	if (subtotalWithoutPromoItems < giftPromo?.threshold && promoItems?.length > 0) {
		await updateGiftItems(promoItems, 0, () => promotionFeatures(window.promotions));
	}

	// Remove promotions that require a coupon code, and remove any applied promo items already in the cart
	promotions = promotions.filter((promotion) => {
		if (promotion.coupon) {
			const coupon = cartData.cart_level_discount_applications.find((code) => code.title == promotion.coupon);
			if (!coupon) {
				// If there are any cart items with this promo property, remove them with updateGiftItems()
				const promoItems = cartItems.filter((item) => item.properties._promo == promotion.properties._promo);
				if (promoItems.length > 0) {
					updateGiftItems(promoItems, 0);
				}
				return false;
			}
		}
		return true;
	});

	// Get user's vanity key from local storage, and remove any promotions that require a vanity key that doesn't match, or if the user has no vanity key
	const vanityKey = getLocalStorage("vanity");
	promotions = promotions.filter((promotion) => {
		if (promotion.vanity && promotion.vanity !== vanityKey) {
			// If there are any cart items with this promo property, remove them with updateGiftItems()
			const promoItems = cartItems.filter((item) => item.properties._promo == promotion.properties._promo);
			if (promoItems.length > 0) {
				updateGiftItems(promoItems, 0);
			}
			return false;
		}
		return true;
	});

	const hasSubscription = cartItems.some((item) => item.selling_plan_allocation);

	renderProgressBar(promotions, cartSubtotal, subCartSubTotal, promoItems, hasSubscription);

	// Loop through gift tiers and check if they apply
	promotions.forEach((promo) => {
		if (promo.promo == "gift_tier") {
			// Gift Tier Promotion
			let giftQuantity = 0;
			let promoSubTotal = subtotalWithoutPromoItems;
			let localCurrencyThreshold = promo.threshold * Shopify.currency.rate;
			// If promo has exlusion products, remove those from the subtotal
			if (promo.excludeProducts) {
				const excludedItems = cartItems.filter((item) => promo.excludeProducts.includes(item.variant_id));
				const excludedSubtotal = excludedItems.reduce((subtotal, item) => subtotal - item.final_line_price, 0);
				promoSubTotal += excludedSubtotal;
			}
			let promoQuantity = cartQuantity;
			if (promo.subscriptionOnly) {
				promoSubTotal = subCartSubTotal;
				promoQuantity = subCartQuantity;
			}
			if (promo.oneTimeOnly) {
				promoSubTotal -= subCartSubTotal;
				promoQuantity -= subCartQuantity;
			}
			if (promo.type == "price" && promoSubTotal >= localCurrencyThreshold) {
				giftQuantity = promo.quantity;
			} else if (promo.type == "quantity" && promoQuantity >= localCurrencyThreshold) {
				giftQuantity = promo.quantity;
			}
			checkGiftItem(promo.giftsVariantId, giftQuantity, promo.properties, promo.noStack);
		} else if (promo.promo == "bogo_promo") {
			// BOGO Promotion
			if (promo.type == "quantity") {
				let requiredQuantity = 0;
				promo?.bogoRequired.forEach((variantId) => {
					const requiredItem = cartItems.find((item) => item.variant_id == variantId);
					if (requiredItem) {
						if (promo.subscriptionOnly && requiredItem.selling_plan_allocation) {
							requiredQuantity += requiredItem.quantity;
						} else if (!promo.subscriptionOnly) {
							requiredQuantity += requiredItem.quantity;
						}
					}
				});
				let giftQuantity = Math.floor(requiredQuantity / promo.threshold);
				if (promo.limitUse && giftQuantity > promo.limitUse) {
					giftQuantity = promo.limitUse;
				}
				checkGiftItem(promo.giftsVariantId, giftQuantity, promo.properties, promo.noStack, promo);
			}
		}
	});

	// Function to check if gift item should be added or removed
	async function checkGiftItem(giftsVariantId, quantity, properties, noStack = false, promo) {
		// Check if no stack gift item is already in cart, if so bail
		let noStackBlock = false;
		if (noStack) {
			const noStackItem = cartItems.find((item) => item.properties._promo == noStack);
			if (noStackItem) {
				// console.log("No Stack Item is in cart, so no gift item will be added");
				noStackBlock = true;
			}
		}

		// Check if gift item is already in cart with variantId and property
		let hasGiftItems = true;
		let giftItems = [];
		if (giftsVariantId) {
			giftsVariantId.forEach((variantId) => {
				const giftItem = cartItems.find((item) => promo?.bogoRequired.includes(item.properties._giftOverride) || (item.variant_id == variantId && item.properties._promo == properties._promo));
				if (!giftItem) {
					hasGiftItems = false;
				} else {
					// Build associative array of gift item key and index
					giftItems.push({
						key: giftItem.key,
						index: cartItems.findIndex((item) => item.variant_id == variantId && item.properties._promo == properties._promo),
						quantity: giftItem.quantity,
					});
				}
			});
		}
		// If gift item is not in cart, add it
		if (!hasGiftItems && quantity > 0 && !noStackBlock) {
			if (window.disableAddGift && promo?.promo === 'bogo_promo') return;
			await addGiftItems(giftsVariantId, quantity, properties);
			// If gift item is in cart with different quantity, update it
		} else if (hasGiftItems && quantity < giftItems[0].quantity) {
			await updateGiftItems(giftItems, quantity);
		}
	}
}

/* HELPER FUNCTIONS */
// Return cart data as JSON
async function getCartData() {
	const response = await fetch(`${routes.cart_url}.js`);
	const data = await response.json();
	return data;
}

// Add gift item to cart
async function addGiftItems(giftsVariantId, quantity, properties) {

	const cartDrawerItems = document.querySelector('cart-drawer-items');
	const quantityInput = cartDrawerItems.querySelectorAll('quantity-input');
	// Disable all quantityInput children
	quantityInput.forEach((e) => {
		e.childNodes.forEach((input) => {
			if (input.nodeName !== '#text') {
				input.setAttribute('disabled', 'disabled');
			}
		});
	});

	const giftItems = giftsVariantId.map((variantId) => {
		return {
			id: variantId,
			quantity: quantity,
			properties: properties,
		};
	});

	const giftItem = {
		items: giftItems,
		sections: ['cart-drawer','cart-icon-bubble'],
	};

	try {
		const response = await fetch(`/cart/add.js`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(giftItem)
		});
		if (response.ok) {
			await renderCartDrawer(response);
		} else {
			console.error("Bad Response, items not added");
			
			quantityInput.forEach((e) => {
				e.childNodes.forEach((input) => {
					if (input.nodeName !== '#text') {
						input.removeAttribute('disabled');
					}
				});
			});
		}
	} catch (error) {
		console.error("Gift Tier Error:", error);
	}
}

// Remove gift item from cart
async function updateGiftItems(giftItems, quantity, callback) {
	let updates = {};
	giftItems.forEach((item) => {
		updates = {
			...updates,
			[item.key || item.id]: quantity ?? item.quantity,
		};
	});

	try {
		const response = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({
				updates,
				sections: ['cart-drawer','cart-icon-bubble'],
			}),
		});
		if (response.ok) {
			await renderCartDrawer(response);
			if (callback) callback();
		} else {
			console.error("Bad Response, item not removed");
		}
	} catch (error) {
		console.error("Gift Tier Error:", error);
	}
}

window.getCartData = getCartData;
window.addGiftItems = addGiftItems;
window.updateGiftItems = updateGiftItems;

// Section API Reload Cart-Drawer
async function renderCartDrawer(response) {
	const { sections } = await response.json();
	const cartDrawer = document.querySelector("cart-drawer");
	const cartIconBubble = document.querySelector("#cart-icon-bubble");
	// Convert the HTML string into a document object that can be parsed to replace the cart drawer
	const parser = new DOMParser();
	const drawerHtml = parser.parseFromString(sections["cart-drawer"], "text/html");
	const bubbleHtml = parser.parseFromString(sections["cart-icon-bubble"], "text/html");
	// Get the new cart drawer and replace the existing one, and check if is empty to add class
	cartDrawer.querySelector(".drawer__inner").replaceWith(drawerHtml.querySelector(".drawer__inner"));
	if (drawerHtml.querySelector("cart-drawer").classList.contains("is-empty")) {
		// console.log("Cart Drawer is empty");
		cartDrawer.classList.add("is-empty");
	} else {
		cartDrawer.classList.remove("is-empty");
	}
	// Get the new cart drawer and replace the existing one, and check if is empty to add class
	cartIconBubble.innerHTML = bubbleHtml.querySelector(".shopify-section").innerHTML;
}

// Get a Local Storage from key
function getLocalStorage(key) {
	try {
		return localStorage.getItem(key);
	} catch (error) {
		// Handle the error here
		console.error("Error getting local storage from ", key, ": ", error);
	}
}

// Render Progress Bar
function renderProgressBar(promotions, cartTotal = 0, subCartSubTotal = 0, promoItems, hasSubscription = false) {
	if (promotions.length > 0) {
		promotions = promotions.filter((promotion) => promotion.type !== "quantity" && promotion.excludeProgressBar !== true);
	}
	// If promotions array is empty, remove the progress bar from the DOM and bail
	if (promotions.length === 0) {
		document.querySelector(".drawer__promo-progress-bar").remove();
		return;
	}
	// Define the highest threshold value
	let highestThreshold = 0;
	let highestThresholdIsShipping = false;
	promotions.forEach((promotion) => {
		const localCurrencyThreshold = promotion.threshold * Shopify.currency.rate;
		if (promotion.threshold > highestThreshold) {
			highestThreshold = localCurrencyThreshold;
			if (promotion.promo === 'free_shipping') {
				highestThresholdIsShipping = true;
			}
		}
	});

	if (highestThresholdIsShipping && hasSubscription) {
		highestThreshold = 0;
	}

	// Get cart total and calculate progress, and round down to nearest whole number, and max out at 100
	let progress = Math.floor((cartTotal / highestThreshold) * 100);
	progress = progress > 100 ? 100 : progress;
	let subProgress = Math.floor((subCartSubTotal / highestThreshold) * 100);
	subProgress = subProgress > 100 ? 100 : subProgress;
	// console.log("Progress: " + progress + "% out of " + highestThreshold + ' with cart total: ' + cartTotal);
	// console.log("Sub Progress: " + subProgress + "% out of " + highestThreshold + ' with cart of subs: ' + subCartSubTotal);

	// Set progress bar width
	document.querySelector(".drawer__promo-progress-bar .percentage").style.width = progress + "%";
	document.querySelector(".drawer__promo-progress-bar .sub-percentage").style.width = subProgress + "%";

	if (progress === 100) document.querySelector('.progress-bar').classList.add("progress-bar--full");
	else document.querySelector('.progress-bar').classList.remove("progress-bar--full");

	// Place icons on the progress bar for each promotion
	let upcomingIcon = true;
	promotions.forEach((promotion, index) => {
		const iconId = `icon-${index}`;
		let icon = document.getElementById(iconId);
		const isInternational = Shopify.country !== 'US' && Shopify.country !== 'CA' && promotion.promo === 'free_shipping';
		if (!icon) {
			icon = document.createElement("div");
			icon.id = iconId;
			icon.classList.add("icon", `icon-${promotion.promo}`);
			if (!isInternational) {
				document.querySelector(".drawer__promo-progress-bar .progress-bar").appendChild(icon);
			}
		}
		const localCurrencyThreshold = promotion.threshold * Shopify.currency.rate;
		let iconPercentage = Math.floor((localCurrencyThreshold / highestThreshold) * 100);
		iconPercentage = iconPercentage > 100 ? 100 : iconPercentage;
		icon.style.left = iconPercentage + "%";

		// Build Gift Name
		let giftsName = promotion.name;
		if (!giftsName) {
			if (Array.isArray(promotion.giftName)) {
				promotion.giftName.forEach((gift) => {
					giftsName += gift;
					if (promotion.giftName.indexOf(gift) !== promotion.giftName.length - 1) {
						giftsName += " &amp; ";
					}
				});
			} else {
				giftsName = promotion.giftName;
			}
			// console.log('Gifts Name: ' + giftsName);
		}

		let iconProgress = 0;
		if (promotion.subscriptionOnly) {
			icon.classList.add("icon-subscription");
			iconProgress = subProgress;
		} else {
			iconProgress = progress;
		}

		if (iconProgress >= iconPercentage) {
			icon.classList.add("active");
			if (promotion.achieved) {
				document.querySelector(".drawer__promo-progress-bar .message").innerHTML = promotion.achieved;
			} else {
				document.querySelector(".drawer__promo-progress-bar .message").innerHTML = `<p>You got <strong>${giftsName}</strong> - Hooray!!</p>`;
			}
		} else {
			icon.classList.remove("active");
			// If the previous icon is active, show the remaining amount to the next gift
			if (upcomingIcon) {
				const localCurrencyThreshold = promotion.threshold * Shopify.currency.rate
				const isInternational = Shopify.country !== 'US' && Shopify.country !== 'CA';
				let remainingAmount = ((localCurrencyThreshold - cartTotal) / 100).toFixed(2);
				remainingAmount = formatCurrency(remainingAmount, Shopify.currency.active);
				const giftTierMessage = isInternational ? `<p>You're <strong>${remainingAmount}</strong> away from ${giftsName}!</p>` : `<p>You got <strong>FREE SHIPPING</strong>!<br/>You're <strong>${remainingAmount}</strong> away from ${giftsName}!</p>`
				const message = promotion.promo === 'gift_tier' ? giftTierMessage : `<p>You're <strong>${remainingAmount}</strong> away from ${giftsName}!</p>`
				document.querySelector(".drawer__promo-progress-bar .message").innerHTML = message;
				upcomingIcon = false;
			}
		}
	});
}

function formatCurrency(amount, currencyCode = 'USD') {
	return new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency: currencyCode
	}).format(amount);
}
